import type { ComplianceScanResult, ComplianceService } from '../complianceService';
import { httpRequestWithRefresh, type HttpClientConfig } from './httpApiClient';
import { unwrapResult } from './httpEnvelope';

/**
 * HTTP impl of :type:`ComplianceService`(docs/76 §8.1)。
 * -----------------------------------------------------------------------------
 * 單一 endpoint;stateless POST。cookie + CSRF + `X-Current-Group` + 401 refresh
 * chain 沿 `httpRequestWithRefresh`(非 exempt path 自動注入)。
 */
const PATH = {
  scan: (pid: string) => `/api/projects/${encodeURIComponent(pid)}/compliance/scan`,
} as const;

export function createHttpComplianceService(config: HttpClientConfig): ComplianceService {
  return {
    async scan(projectId: string, texts: string[]): Promise<ComplianceScanResult> {
      const env = await httpRequestWithRefresh<ComplianceScanResult>(
        config,
        'POST',
        PATH.scan(projectId),
        { texts },
      );
      return unwrapResult(env, 'compliance.scan');
    },
  };
}
